// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"203":"9a28b6e22a24e225","615":"eb6f3f605b36f91e"}[chunkId] + ".css";
};